import axios, { AxiosResponse, AxiosError } from 'axios'

import buildUrl from 'build-url'
import Cookie from 'js-cookie'
import store from '@/store/index'
import { AccountState } from './account/types'

export const apiUrl = process.env.VUE_APP_API_URL as string

const camelToSnakeCase = (camel: string): string => {
  return camel.replace(/[\w]([A-Z])/g, (m) => m[0] + '_' + m[1]).toLowerCase()
}

const autoBuildUrl = (path: string, params: {[key: string]: string}): string => {
  const queryParams: {[key: string]: string } = {}
  for (const key in params) {
    if (params[key] !== '') {
      queryParams[camelToSnakeCase(key)] = params[key]
    }
  }
  return buildUrl(apiUrl, { path, queryParams })
}

class Adapter {
  private cache: { [key: string]: any } = {}

  public postRequest = (
    subPath: string,
    payload: any,
    sendToken?: boolean,
    options?: {},
    headers?: {}): Promise<any> => {
    return new Promise((resolve, reject) => {
      this.cache = {} // Clear cache since we are changing content, TODO: Remove this, instead update store per action
      axios.post(apiUrl + subPath, payload, this.buildOptions(sendToken, options, headers)
      ).then((response: AxiosResponse) => {
        resolve(response.data)
      }).catch((error: AxiosError) => {
        reject(error.response)
      })
    })
  }

  public deleteRequest = (
    subPath: string,
    params?: {[key: string]: string },
    sendToken?: boolean,
    options?: {},
    headers?: {}): Promise<any> => {
    this.cache = {} // Clear cache since we are changing content, TODO: Remove this, instead update store per action
    const url = autoBuildUrl(subPath, params || {})
    return new Promise((resolve, reject) => {
      axios.delete(url, this.buildOptions(sendToken, options, headers))
        .then((response: AxiosResponse) => {
          resolve(response.data)
        }).catch((error: AxiosError) => {
          reject(error.response)
        })
    })
  }

  public getRequest = (
    subPath: string,
    params?: {[key: string]: string },
    sendToken?: boolean,
    cache?: boolean,
    options?: {},
    headers?: {}): Promise<any> => {
    const url = autoBuildUrl(subPath, params || {})
    return new Promise((resolve, reject) => {
      if (cache === true && url in this.cache) {
        resolve(this.cache[url])
      }
      axios.get(url, this.buildOptions(sendToken, options, headers))
        .then((response: AxiosResponse) => {
          if (cache === true) {
            this.cache[url] = response.data
          }
          resolve(response.data)
        }).catch((error: AxiosError) => {
          reject(error.response)
        })
    })
  }

  private buildOptions = (sendToken?: boolean, options?: {}, extraHeaders?: {}) => {
    const headers: { [key: string]: string } = {
      'Content-type': 'application/json',
      ...extraHeaders
    }
    if (sendToken) {
      headers.Authorization = 'Token ' + (store.state.account as AccountState).token
    } else {
      options = {
        csrfmiddlewaretoken: Cookie.get('csrftoken'), ...options
      }
    }
    return { withCredentials: false, headers, ...options }
  }
}

export const adapter = new Adapter()
